import { atom } from 'recoil'

export const LoginState = atom({
  key: 'loginState',
  default: {
    isLoggedIn: false,
    role: null, // "admin" | "subadmin" | "employee"
  },
})
